import { render } from "./program-details.vue?vue&type=template&id=67c97eaf"
import script from "./program-details.vue?vue&type=script&lang=js"
export * from "./program-details.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__